import { TierKey } from 'generated/types'

export const DowngradeStartViewed = {
  object_name: 'downgradeSubscription',
  screen: 'downgradeSubscription',
  screen_name: 'downgradeSubscription',
  origin: 'downgrade',
}

export const DowngradeStartCTA = {
  object_name: 'downgradeSubscriptionCTA',
  screen: 'downgradeSubscription',
  screen_name: 'downgradeSubscription',
  origin: 'downgrade',
  cta_title: 'Get started',
}

export const ConfirmDowngradeViewed = {
  object_name: 'downgradeSubscriptionConfirmation',
  screen: 'downgradeSubscriptionConfirmation',
  screen_name: 'downgradeSubscriptionConfirmation',
  origin: 'downgrade',
}

export const ConfirmDowngradeClosureCTA = {
  object_name: 'downgradeSubscriptionConfirmationCTA',
  screen: 'downgradeSubscriptionConfirmation',
  screen_name: 'downgradeSubscriptionConfirmation',
  origin: 'downgrade',
  cta_title: 'Withdraw and request closure',
}

export const ConfirmDowngradeClosureCancelCTA = {
  object_name: 'downgradeSubscriptionConfirmationCancel',
  screen: 'downgradeSubscriptionConfirmation',
  screen_name: 'downgradeSubscriptionConfirmation',
  origin: 'downgrade',
  cta_title: 'Never mind',
}

export const ConfirmDowngradeClosureConfirmCTA = {
  object_name: 'downgradeSubscriptionConfirmationConfirm',
  screen: 'downgradeSubscriptionConfirmation',
  screen_name: 'downgradeSubscriptionConfirmation',
  origin: 'downgrade',
  cta_title: 'Continue',
}

export const DowngradeDoneViewed = (
  previousTier: TierKey,
  currentTier: TierKey,
) => ({
  object_name: 'downgradeSubscriptionDone',
  screen: 'downgradeSubscriptionDone',
  screen_name: 'downgradeSubscriptionDone',
  previous_tier: previousTier,
  current_tier: currentTier,
})

export const DowngradeDoneCTA = {
  object_name: 'downgradeSubscriptionDoneCTA',
  screen: 'downgradeSubscriptionDone',
  screen_name: 'downgradeSubscriptionDone',
  cta_title: 'Done/ X',
}
